import { _, moment } from "../../../../../vendor";
import t from "../../../helpers/t";
import { rbac } from "../index";
import { Biscuit } from "../../../../utils";
import { checkAndParseJson, in_array } from "../../../../utils/Helper";
import {
  ordersActions,
  reservationsActions,
  userActions,
  useSelector,
  webFEActions,
} from "inbooma-api";
import * as OrderFunctions from "./behaviors/OrderFunctions";
import ReservationListItem from "./ReservationListItem";
import OrderListItem from "./OrderListItem";
import ReservationListExtraItem from "./ReservationListExtraItem";
import React, { useEffect, useState } from "react";
import { dateFormat, timeFormat } from "../../../../utils/FormatHelper";
import { getEnv } from "../../../../Sync";

const ReservationItem = (props) => {
  const {
    reservation,
    index,
    dispatch,
    _exchangeLabel,
    setCheckout,
    checkout,
    setCheckoutCheckin,
    setCheckoutReservation,
    setFilter,
    filter,
    setNKey,
    sort,
    setSort,
    _key,
    locations,
    setPopup,
    popup,
    filterChangedHandle,
    showNotification,
    currentUrl,
    params,
    openChangeLog,
    onShowLog,
  } = props;
  let language = Biscuit.get("user.lang").replace("-", "_");
  const searchParams = currentUrl.searchParams;
  const [reservationLocal, setReservationLocal] = useState(reservation);
  const [reservationPending, setReservationPending] = useState(false);
  const [orderPending, setOrderPending] = useState(false);
  const _patchReservation = useSelector((state) => state.reservations.patchReservations);
  const _patchOrder = useSelector((state) => state.orders.patchOrder);
  const _webFE = useSelector((state) => state["web_fe_data"].webFE_items);

  useEffect(() => {
    if (!reservationPending || _patchReservation.success === "") {
      return;
    }

    if (_patchReservation.success === true) {
      const clone = {};
      Object.assign(clone, reservationLocal);
      clone.status = _patchReservation.data.status;
      setReservationLocal(clone);
      showNotification(
        "success",
        typeof reservationLocal.order !== "undefined"
          ? reservationLocal.order.order_nbr
          : reservationLocal.id,
        "",
        "reservation",
      );
    } else {
      showNotification(
        "warning",
        null,
        typeof _patchReservation.data.message !== "undefined"
          ? _patchReservation.data.message
          : t("could_not_be_saved_${a}", { a: t("reservation") }, "capital") +
              " #" +
              (typeof reservationLocal.order !== "undefined"
                ? reservationLocal.order.order_nbr
                : reservationLocal.id),
      );
      console.log("Failed patching reservation!");
    }
    setReservationPending(null);
    // props.filterChangedHandle(props.filter);
  }, [_patchReservation]);

  useEffect(() => {
    if (!orderPending || _patchOrder.success === "") {
      return;
    }

    if (_patchOrder.success === true) {
      const clone = {};
      Object.assign(clone, reservationLocal);
      clone.order.status = _patchOrder.data.status;
      setReservationLocal(clone);
      showNotification("success", _patchOrder.data.order_nbr, "", "order");
    } else {
      showNotification(
        "warning",
        null,
        typeof _patchOrder.data.message !== "undefined"
          ? _patchOrder.data.message
          : t("could_not_be_saved_${a}", { a: t("order") }, "capital") +
              " #" +
              reservationLocal.order.order_nbr,
      );
      console.log("Failed patching order!");
    }
    setOrderPending(null);
    // props.filterChangedHandle(props.filter);
  }, [_patchOrder]);

  useEffect(() => {
    if (_webFE !== {} && typeof _webFE.data !== "undefined" && _webFE.data.length > 0) {
      _webFE.data.map((item) => {
        if (
          item.app === null ||
          (item.app === Biscuit.get("user.id") &&
            item.model === "Reservations" &&
            item.client_id === Biscuit.get("user.client_id") &&
            item.environment === getEnv() &&
            item.id === reservationLocal.id)
        ) {
          const clone = {};
          Object.assign(clone, reservationLocal);
          Object.keys(item).map((it) => {
            if (!in_array(it, ["id", "_id"])) {
              clone[it] = item[it];
            }
          });
          setReservationLocal(clone);
          dispatch(webFEActions.removeWebFEItemById({ id: item._id }));
        }
      });
    }
  }, [_webFE]);

  useEffect(() => {
    fillData();
  }, [reservationPending, orderPending]);

  const onItemClickedHandler = (value) => {
    console.log("clicked on: ", value);
    if (value.startsWith("acc_invoice_")) {
      // open accumulated invoice
      const id = value.split("acc_invoice_")[1];
    }
    if (value.startsWith("user_")) {
      // fetch user info
      const id = value.split("user_")[1];
      const el_rect = document.getElementsByName(value)[0].getBoundingClientRect();

      dispatch(
        userActions.getUser({
          token: Biscuit.get("token"),
          id: id,
          parameters: {
            headers: {
              "Accept-Language": language,
              "Content-Language": language,
            },
          },
        }),
      );

      setPopup({
        ...popup,
        left: el_rect.left + "px",
        top: el_rect.top + "px",
        text: t("user", null, "capital") + ":",
      });
    }
    if (value.startsWith("payment_info_")) {
      const idx = value.split("payment_info_")[1];
      const el_rect = document.getElementsByName(value)[0].getBoundingClientRect();

      setPopup({
        ...popup,
        left: el_rect.left + "px",
        top: el_rect.top + "px",
        open: true,
        text: t("payment_error_info") + ": " + wallets[idx].message,
        link: "",
        linkText: "",
      });
    }
  };

  const onStatusChangedHandler = (e, item) => {
    if (typeof item.order_id !== "undefined") {
      dispatch(
        reservationsActions.patchReservations({
          token: Biscuit.get("token"),
          reservation_id: item.id,
          data: {
            status: e.target.value,
          },
          parameters: {
            headers: {
              "Accept-Language": language,
              "Content-Language": language,
            },
          },
        }),
      );
      setReservationPending(true);
    } else {
      dispatch(
        ordersActions.patchOrder({
          token: Biscuit.get("token"),
          order_id: item.id,
          data: {
            status: e.target.value,
          },
          parameters: {
            headers: {
              "Accept-Language": language,
              "Content-Language": language,
            },
          },
        }),
      );
      setOrderPending(true);
    }
  };

  let orderIds = [],
    reservationData = null;
  const fillData = () => {
    reservationData = null;
    let reserv;
    let hasOrder = false;
    let hasCheckIn = false;
    let hasMultipleCheckIns = false;
    let hasValidCheckin = false,
      hasACheckedInResource = false;
    let toggle = false;
    hasCheckIn = false;
    hasMultipleCheckIns = false;
    hasValidCheckin = false;
    hasACheckedInResource = false;
    reserv = reservationLocal;
    toggle = false;
    if (
      typeof searchParams.get("item") !== "undefined" &&
      searchParams.get("item") !== null &&
      Number(reserv.id) === Number(searchParams.get("item"))
    ) {
      toggle = true;
    }
    hasOrder = typeof reserv.order !== "undefined" && reserv.order !== null;
    let order = null;
    if (hasOrder) {
      order = reserv.order;
    }
    hasCheckIn =
      typeof reserv.checkins !== "undefined" &&
      reserv.checkins !== null &&
      reserv.checkins.length > 0;
    let showInfoIcon = false,
      showInfoIconIn = false,
      showInfoIconEx = false,
      infoTextEx = "",
      showInfoColor = false;
    if (hasCheckIn && hasOrder) {
      reserv["checkins"].map((chk) => {
        if (chk.status === "inprogress") {
          if (chk.checkout === null) {
            hasACheckedInResource = true;
          }
        }
        if (chk.modified_by === order.user_id && order.status === "cancelled") {
          hasValidCheckin = true;
        }
        let infoText = checkAndParseJson(chk.comment_checkout);
        let infoTextIn = checkAndParseJson(chk.comment_checkin);
        infoText += checkAndParseJson(reserv.external_note);

        if (infoText !== "") {
          showInfoIcon = true;
          showInfoColor = true;
        }
        if (infoTextIn !== "") {
          showInfoIconIn = true;
          showInfoColor = true;
        }
        if (chk.place_checkout !== null) {
          infoText += checkAndParseJson(chk.place_checkout);
        }
        if (chk.place_checkin !== null) {
          infoTextIn += checkAndParseJson(chk.place_checkin);
        }
      });
    }
    if (!hasCheckIn && hasOrder) {
      if (reserv["external_note"] !== null && reserv["external_note"] !== "") {
        infoTextEx += (infoTextEx !== "" ? "//" : "") + checkAndParseJson(reserv["external_note"]);
      }
      if (reserv["feedback"] !== null && reserv["feedback"] !== "") {
        infoTextEx += (infoTextEx !== "" ? "//" : "") + checkAndParseJson(reserv["feedback"]);
      }
      if (reserv["comment_feedback"] !== null && reserv["comment_feedback"] !== "") {
        infoTextEx +=
          (infoTextEx !== "" ? "//" : "") + checkAndParseJson(reserv["comment_feedback"]);
      }
      if (infoTextEx !== "") {
        showInfoIconEx = true;
      }
    }

    hasMultipleCheckIns = hasCheckIn && reserv["checkins"].length > 0;
    let addClasses = "";
    if (reserv.status === "cancelled") {
      addClasses += " is-cancelled";
    }
    let hasFormData = false,
      hasTour = false;
    if (hasOrder) {
      if (order !== null && typeof order.tag_list !== "undefined") {
        let tags = order.tag_list.split(",");
        _.each(tags, function (val) {
          if (val.trim() === "Anlieferungen") {
            hasFormData = true;
          }
          if (val.trim() === "Tour") {
            hasTour = true;
          }
        });
      }
    }
    if (hasFormData && (reserv.status === "confirmed" || reserv.status === "paid")) {
      addClasses += " has-form-data";
    } else if (hasFormData && reserv.status === "requested") {
      addClasses += " has-form-data-requested";
    } else if (showInfoColor) {
      addClasses += " has-info-data";
    } else {
      addClasses += " has-no-form-data";
    }

    if (hasTour) {
      addClasses += " has-tour";
    } else {
      addClasses += " has-no-tour";
    }
    if (hasOrder) {
      if (reserv.order.types === "service") {
        addClasses += " is-service";
      } else {
        addClasses += " is-no-service";
      }
    } else {
      addClasses += " is-no-service";
    }
    if (toggle) {
      addClasses += " toggled";
    }
    let elements = [];
    if (!hasFormData) {
      let endReserv =
        reserv.end !== null &&
        moment(reserv.end).format(dateFormat(language)) !==
          moment(reserv.begin).format(dateFormat(language));
      elements = [
        {
          type: "text",
          value: "date",
          title: "",
          extraClasses: "inb-order-date",
          data: [
            {
              value: "date",
              text: !endReserv
                ? moment(reserv.begin).format(dateFormat(language, true))
                : {
                    0: moment(reserv.begin).format(dateFormat(language, true)),
                    1: moment(reserv.end).format(dateFormat(language, true)),
                  },
              extraClasses: "inb-order-date__start inb-order-big newline show-label",
              title: !endReserv
                ? t("reservation", null, "capital") +
                  " " +
                  t("valid_from", null, "") +
                  " " +
                  moment(reserv.begin).format(dateFormat(language, true))
                : {
                    0:
                      t("reservation", null, "capital") +
                      " " +
                      t("valid_from", null, "") +
                      " " +
                      moment(reserv.begin).format(dateFormat(language, true)),
                    1:
                      t("reservation", null, "capital") +
                      " " +
                      t("valid_to", null, "") +
                      " " +
                      moment(reserv.end).format(dateFormat(language, true)),
                  },
            },
            {
              value: "date",
              text: {
                0: moment(reserv.begin).format(timeFormat(language)),
                1: moment(reserv.end).format(timeFormat(language)),
              },
              extraClasses: "inb-order-date__end",
              title: {
                0: t("begin_booking") + " " + moment(reserv.begin).format(timeFormat(language)),
                1: t("end_booking") + " " + moment(reserv.end).format(timeFormat(language)),
              },
            },
          ],
          largeWidth: 2,
          mediumWidth: 12,
          smallWidth: 12,
          extraTopClasses: "large-2",
          handler: onItemClickedHandler,
        },
        {
          type: "text",
          value: "order_nbr",
          title: "",
          extraTopClasses: "",
          data: [
            rbac.hasPermission("edit")
              ? {
                  value: "order_nbr",
                  text: hasOrder ? reserv.order.order_nbr : "",
                  extraClasses: "newline show-for-large",
                  title: t("order_nbr", null, "capital"),
                  ref: "/reservationsList/" + reserv.id + "/edit",
                }
              : {
                  value: "order_nbr",
                  text: hasOrder ? reserv.order.order_nbr : "",
                  extraClasses: "newline show-label",
                  title: t("order_nbr", null, "capital"),
                },
            rbac.hasPermission("edit")
              ? {
                  value: "order_nbr",
                  text: hasOrder
                    ? t("order_nbr", null, "capital") + ": " + reserv.order.order_nbr
                    : "",
                  extraClasses: "newline hide-for-large show-label",
                  title: t("order_nbr", null, "capital"),
                  ref: "/reservationsList/" + reserv.id + "/edit",
                }
              : {
                  value: "order_nbr",
                  text: hasOrder
                    ? t("order_nbr", null, "capital") + ": " + reserv.order.order_nbr
                    : "",
                  extraClasses: "newline show-label",
                  title: t("order_nbr", null, "capital"),
                },
            {
              value: "order_payment",
              text: hasOrder ? OrderFunctions.getPayStatus(reserv?.order) : "",
              extraClasses: "text-small show-label",
              title: t("payments", null, "capital"),
            },
            {
              value: "info",
              text: infoTextEx,
              show: showInfoIconEx,
              type: "info",
            },
          ],
          largeWidth: 1,
          mediumWidth: 12,
          smallWidth: 12,
          handler: onItemClickedHandler,
        },
        {
          type: "function",
          value: "description",
          title: "",
          extraTopClasses: "",
          data: [
            rbac.hasPermission("edit")
              ? {
                  value: "user",
                  text: OrderFunctions.getOrderUsername(reserv?.order),
                  extraClasses: "newline show-label",
                  title: t("user", null, "capital"),
                  ref: OrderFunctions.getOrderUserLink(
                    reserv?.order,
                    "/reservations/reservationsList?" + searchParams,
                  ),
                }
              : {
                  value: "user",
                  text: OrderFunctions.getOrderUsername(reserv?.order),
                  extraClasses: "newline show-label",
                  title: t("user", null, "capital"),
                },
            {
              value: "contingents",
              text: OrderFunctions.printReservationContingentsAmountList(reserv, false),
              extraClasses: "inb-reservation--object show-label",
              title: t("contingent", null, "capital"),
            },
          ],
          largeWidth: 2,
          mediumWidth: 12,
          smallWidth: 12,
          handler: onItemClickedHandler,
        },
        {
          type: "text",
          value: "begin_location",
          title: "",
          extraTopClasses: "",
          data: [
            {
              value: "begin_location",
              text: reserv.begin_location_name,
              extraClasses: "text-small show-for-large",
              title: t("location_of_checkin", null, "capital"),
            },
            {
              value: "begin_location",
              text: t("location_of_checkin", null, "capital") + ": " + reserv.begin_location_name,
              extraClasses: "text-small hide-for-large show-label",
              title: t("location_of_checkin", null, "capital"),
            },
          ],
          largeWidth: 2,
          mediumWidth: 12,
          smallWidth: 12,
          handler: onItemClickedHandler,
        },
        {
          type: "text",
          value: "end_location",
          title: "",
          extraTopClasses: "",
          data: [
            {
              value: "end_location",
              text: reserv.end_location_name,
              extraClasses: "text-small show-for-large",
              title: t("location_of_checkout", null, "capital"),
            },
            {
              value: "end_location",
              text: t("location_of_checkout", null, "capital") + ": " + reserv.end_location_name,
              extraClasses: "text-small hide-for-large show-label",
              title: t("location_of_checkout", null, "capital"),
            },
          ],
          largeWidth: 2,
          mediumWidth: 12,
          smallWidth: 12,
          handler: onItemClickedHandler,
        },
        rbac.hasPermission("editStatus")
          ? {
              type: "select",
              value: reserv.status,
              title: t("status"),
              data: OrderFunctions.getStatusSelect(reserv),
              extraClasses: "text-small word-break-all show-label",
              largeWidth: 2,
              mediumWidth: 12,
              smallWidth: 12,
              badge: true,
              extraData: reserv,
              extraTopClasses: "",
              handler: onStatusChangedHandler,
            }
          : {
              type: "text",
              value: reserv.status,
              title: t("status"),
              data: [
                {
                  value: "status",
                  text: t(reserv.status),
                  extraClasses: "",
                  title: "",
                },
              ],
              extraClasses: "text-small word-break-all show-label",
              largeWidth: 2,
              mediumWidth: 12,
              smallWidth: 12,
              extraTopClasses: "",
            },
        rbac.hasPermission("edit")
          ? {
              type: "specialButtons",
              value: t("mietvertrag_help"),
              title: t("mietvertrag_help"),
              extraTopClasses: "",
              data: [
                /*    {
                        value: reserv,
                        icon: "inb-fi-checkin",
                        extraClasses: "inb-round-btn hollow round float-left",
                        ref: "/reservationsList/" + reserv.id + "/checkin",
                        round: true,
                        type: 'open',
                        handler: OrderFunctions._printCheckin,
                        title: hasACheckedInResource ? t('checkout_reservation', null, 'capital') : t('checkin_reservation', null, 'capital')
                    },*/
                {
                  value: reserv,
                  icon: "inb-fi-contract",
                  extraClasses: "inb-round-btn hollow round float-left",
                  ref: "#",
                  round: true,
                  type: "print",
                  handler: OrderFunctions._printRentalContract,
                  title: t("mietvertrag_help", null, "capital"),
                },
              ],
              largeWidth: 1,
              mediumWidth: 6,
              smallWidth: 6,
              handler: OrderFunctions._printRentalContract,
            }
          : {},
      ];

      /* if(hasCheckIn) {
                 elements.push({
                     type: "bar",
                     value: "state",
                     title: "",
                     data: [{
                         value: "state",
                         text: getState(reserv),
                         extraClasses: getStateClasses(reserv),
                         extra: (reserv.checkins[0].checkout !== null ? 'has-checkout' : ""),
                         title: ""
                     }],
                     mediumWidth: 12,
                     smallWidth: 12,
                     handler: onItemClickedHandler
                 });
             }*/
      /* if (reserv.status !== 'cancelled') {
                 elements.push({
                     type: "button",
                     value: (typeof reserv.checkins === 'undefined' || reserv.checkins.length === 0) ? t('checkin_reservation', null, 'capital') : t('checkout_reservation', null, 'capital'),
                     title: (typeof reserv.checkins === 'undefined' || reserv.checkins.length === 0) ? t('checkin_reservation', null, 'capital') : t('checkout_reservation', null, 'capital'),
                     extraTopClasses: "inb-reservation__pdf2",
                     data: [{
                         value: reserv.id,
                         icon: "inb-fi-checkin",
                         extraClasses: "inb-round-btn hollow round float-left",
                         ref: "/reservationsList/" + reserv.id + "/checkin",
                         round: true
                     }],
                     mediumWidth: 1,
                     smallWidth: 1
                 });
             }*/

      if (hasCheckIn && !hasMultipleCheckIns) {
        elements.push({
          type: "CheckInAddition",
          value: "checkins",
          title: "",
          data: [
            {
              value: "checkins",
              text: "",
              title: "",
              order_id: hasOrder ? reserv.order_id : null,
              checkins: reserv.checkins,
              first_usage: reserv.first_usage,
              id: reserv.id,
              app_user_role: Biscuit.get("user.role"),
              reservation: reserv,
              dispatch: dispatch,
              checkout: checkout,
              setCheckout: setCheckout,
              setCheckoutReservation: setCheckoutReservation,
              setCheckoutCheckin: setCheckoutCheckin,
              setNKey: setNKey,
              _key: "wti-" + i,
              filter: filter,
              setFilter: setFilter,
              sort: sort,
              setSort: setSort,
            },
          ],
          largeWidth: 12,
          mediumWidth: 12,
          smallWidth: 12,
          handler: onItemClickedHandler,
        });
      }
    } else {
      let endReserv =
        OrderFunctions.getDeliverEnd(reserv) !== "" &&
        moment(OrderFunctions.getDeliverEnd(reserv)).format(dateFormat(language)) !==
          moment(OrderFunctions.getDeliverBegin(reserv)).format(dateFormat(language));
      let emptyDate =
        OrderFunctions.getDeliverBegin(reserv) === "" ||
        OrderFunctions.getDeliverBegin(reserv) === null;
      if (!in_array(reserv.order_id, orderIds)) {
        orderIds.push(reserv.order_id);
        elements = [
          {
            type: "text",
            value: "date",
            title: "",
            data: [
              {
                value: "date",
                text: emptyDate
                  ? ""
                  : !endReserv
                    ? moment(OrderFunctions.getDeliverBegin(reserv)).format(
                        dateFormat(language, true),
                      )
                    : {
                        0: moment(OrderFunctions.getDeliverBegin(reserv)).format(
                          dateFormat(language, true),
                        ),
                        1: moment(OrderFunctions.getDeliverEnd(reserv)).format(
                          dateFormat(language, true),
                        ),
                      },
                extraClasses: "inb-order-date__start inb-order-big newline",
                title: emptyDate
                  ? ""
                  : !endReserv
                    ? t("reservation", null, "capital") +
                      " " +
                      t("valid_from", null, "") +
                      " " +
                      moment(OrderFunctions.getDeliverBegin(reserv)).format(
                        dateFormat(language, true),
                      )
                    : {
                        0:
                          t("reservation", null, "capital") +
                          " " +
                          t("valid_from", null, "") +
                          " " +
                          moment(OrderFunctions.getDeliverBegin(reserv)).format(
                            dateFormat(language, true),
                          ),
                        1:
                          t("reservation", null, "capital") +
                          " " +
                          t("valid_to", null, "") +
                          " " +
                          moment(OrderFunctions.getDeliverEnd(reserv)).format(
                            dateFormat(language, true),
                          ),
                      },
              },
              {
                value: "date",
                text: emptyDate
                  ? ""
                  : {
                      0: moment(OrderFunctions.getDeliverBegin(reserv)).format(
                        timeFormat(language),
                      ),
                      1: moment(OrderFunctions.getDeliverEnd(reserv)).format(timeFormat(language)),
                    },
                extraClasses: "inb-order-date__end",
                title: emptyDate
                  ? ""
                  : {
                      0:
                        t("begin_booking") +
                        " " +
                        moment(OrderFunctions.getDeliverBegin(reserv)).format(timeFormat(language)),
                      1:
                        t("end_booking") +
                        " " +
                        moment(OrderFunctions.getDeliverEnd(reserv)).format(timeFormat(language)),
                    },
              },
            ],
            largeWidth: 2,
            mediumWidth: 12,
            smallWidth: 12,
            extraTopClasses: "",
            handler: onItemClickedHandler,
          },
          {
            type: "text",
            value: "order_nbr",
            title: "",
            extraTopClasses: "",
            data: [
              rbac.hasPermission("edit")
                ? {
                    value: "order_nbr",
                    text: hasOrder ? reserv.order.order_nbr : "",
                    extraClasses: "newline show-for-large",
                    title: t("order_nbr", null, "capital"),
                    ref: "/reservationsList/" + reserv.id + "/edit",
                  }
                : {
                    value: "order_nbr",
                    text: hasOrder ? reserv.order.order_nbr : "",
                    extraClasses: "newline show-label",
                    title: t("order_nbr", null, "capital"),
                  },
              rbac.hasPermission("edit")
                ? {
                    value: "order_nbr",
                    text: hasOrder
                      ? t("order_nbr", null, "capital") + ": " + reserv.order.order_nbr
                      : "",
                    extraClasses: "newline hide-for-large show-label",
                    title: t("order_nbr", null, "capital"),
                    ref: "/reservationsList/" + reserv.id + "/edit",
                  }
                : {
                    value: "order_nbr",
                    text: hasOrder
                      ? t("order_nbr", null, "capital") + ": " + reserv.order.order_nbr
                      : "",
                    extraClasses: "newline show-label",
                    title: t("order_nbr", null, "capital"),
                  },
              {
                value: "order_payment",
                text: hasOrder ? OrderFunctions.getPayStatus(reserv?.order) : "",
                extraClasses: "text-small show-label",
                title: t("payments", null, "capital"),
              },
              {
                value: "info",
                text: infoTextEx,
                show: showInfoIconEx,
                type: "info",
              },
            ],
            largeWidth: 1,
            mediumWidth: 12,
            smallWidth: 12,
            handler: onItemClickedHandler,
          },
          {
            type: "function",
            value: "description",
            title: "",
            extraTopClasses: "",
            data: [
              {
                value: "user",
                text: OrderFunctions.getDeliverUsername(reserv),
                extraClasses: "newline show-label",
                title: t("user", null, "capital"),
              },
              {
                value: "contingents",
                text: OrderFunctions.printReservationContingentsAmountList(reserv, true),
                extraClasses: "inb-reservation--object show-label",
                title: t("contíngent", null, "capital"),
              },
            ],
            largeWidth: 2,
            mediumWidth: 12,
            smallWidth: 12,
            handler: onItemClickedHandler,
          },
          {
            type: "text",
            value: "begin_location",
            title: "",
            extraTopClasses: "",
            data: [
              {
                value: "begin_location",
                text: OrderFunctions.getLieferOrt(reserv),
                extraClasses: "text-small show-for-large",
                title: t("location_of_checkin", null, "capital"),
              },
              {
                value: "begin_location",
                text:
                  t("location_of_checkin", null, "capital") +
                  ": " +
                  OrderFunctions.getLieferOrt(reserv),
                extraClasses: "text-small hide-for-large show-label",
                title: t("location_of_checkin", null, "capital"),
              },
            ],
            largeWidth: 2,
            mediumWidth: 12,
            smallWidth: 12,
            handler: onItemClickedHandler,
          },
          {
            type: "text",
            value: "end_location",
            title: "",
            extraTopClasses: "",
            data: [
              {
                value: "end_location",
                text: OrderFunctions.getAbholOrt(reserv),
                extraClasses: "text-small show-for-large",
                title: t("location_of_checkout", null, "capital"),
              },
              {
                value: "end_location",
                text:
                  t("location_of_checkout", null, "capital") +
                  ": " +
                  OrderFunctions.getAbholOrt(reserv),
                extraClasses: "text-small hide-for-large show-label",
                title: t("location_of_checkout", null, "capital"),
              },
            ],
            largeWidth: 2,
            mediumWidth: 12,
            smallWidth: 12,
            handler: onItemClickedHandler,
          },
          rbac.hasPermission("edit")
            ? {
                type: "select",
                value: reserv.order.status,
                title: t("status"),
                data: OrderFunctions.getOrderStatusSelect(reserv?.order,props._exchangeLabel),
                extraClasses: "text-small word-break-all inb-order--status show-label",
                largeWidth: 2,
                mediumWidth: 12,
                smallWidth: 12,
                extraTopClasses: "",
                badge: true,
                extraData: reserv.order,
                handler: onStatusChangedHandler,
              }
            : {
                type: "text",
                value: reserv.status,
                title: t("status"),
                data: [
                  {
                    value: "status",
                    text: t(reserv.status),
                    extraClasses: "",
                    title: "",
                  },
                ],
                extraClasses: "text-small word-break-all show-label",
                extraTopClasses: "",
                largeWidth: 2,
                mediumWidth: 12,
                smallWidth: 12,
              } /*,
                        {
                            type: "text",
                            value: reserv.order.price,
                            title: t('price'),
                            data: [{
                                value: "price",
                                text: Number(reserv.order.price).toLocaleString("de-DE", {minimumFractionDigits: 2}) + " " + Biscuit.get('client.currency'),
                                extraClasses: "",
                                title: ""
                            }],
                            extraClasses: "inb-order-price__amount inb-order-big",
                            mediumWidth: 1,
                            smallWidth: 3,
                            handler: onItemClickedHandler
                        }*/,
          rbac.hasPermission("edit")
            ? {
                type: "specialButtons",
                value: t("mietvertrag_help"),
                title: t("mietvertrag_help"),
                extraTopClasses: "",
                data: [
                  {
                    value: reserv.order,
                    icon: "inb-fi-contract",
                    extraClasses: "inb-round-btn hollow round float-left",
                    ref: "#",
                    round: true,
                  },
                ],
                largeWidth: 1,
                mediumWidth: 6,
                smallWidth: 6,
                handler: OrderFunctions._printRentalContractDelivery,
              }
            : {},
        ];
      }
    }
    if (elements !== []) {
      const hasCompletedCheckouts = _.every(reserv.checkins, function (checkin) {
        return (
          (typeof checkin.checkout !== "undefined" && checkin.checkout !== null) ||
          checkin?.status === "cancelled"
        );
      });
      const hasFutureCheckout = _.every(reserv.checkins, function (checkin) {
        return (
          typeof checkin.checkout !== "undefined" &&
          checkin.checkout !== null &&
          moment(checkin.checkout) > moment(new Date())
        );
      });
      const hasFutureCheckin = _.every(reserv.checkins, function (checkin) {
        return (
          typeof checkin.checkin !== "undefined" && moment(checkin.checkin) > moment(new Date())
        );
      });
      /* console.log({
                reservation: reserv,
                hasCompletedCheckouts: hasCompletedCheckouts,
                hasFutureCheckout: hasFutureCheckout,
                hasFutureCheckin: hasFutureCheckin
            });*/

      reservationData = {
        elements: elements,
        addClasses: addClasses,
        hasForm: hasFormData,
        hasMultipleCheckIns: hasMultipleCheckIns,
        hasCompletedCheckouts: hasCompletedCheckouts,
        hasFutureCheckout: hasFutureCheckout,
        hasFutureCheckin: hasFutureCheckin,
        hasValidCheckin: hasValidCheckin,
        changeLogs: reserv.changeLogs,
        info: { show: false, info: infoTextEx },
      };
    }
  };
  fillData();
  let reservationMenu = [
    rbac.hasPermission("edit") && {
      text: t("edit_${a}", { a: t("order", null, "capital") }),
      href: "/orders/" + reservationLocal.order_id + "/edit" + currentUrl.search,
      iconClass: "fi fi-wrench",
      title: "edit",
    },
    rbac.hasPermission("edit") && {
      text: t("add_payment", null, "capital"),
      href:
        "/orders/" + reservationLocal.order_id + "/addpaymentfromreservations" + currentUrl.search,
      iconClass: "fi fi-dollar",
      title: "payments",
    },
    rbac.hasPermission("log") && {
      text: t("show log"),
      href: "#",
      clickHandler: onShowLog,
      reservation: reservationLocal,
      getItem: "reservation",
      iconClass: "fi fi-wrench",
      title: "log",
    },
  ];
  /*  if(Biscuit.get('user.is_superuser')  === 'true'){
        reservationMenu.push({
            text: t('changelog', null, 'capital'),
            href: "#",
            clickHandler: openChangeLog,
            changeLog: reservation.changeLogs,
            iconClass: "fi fi-wrench",
            title: "changelog"
        });
    }*/
  if (!reservationData.hasForm && !reservationData.hasMultipleCheckIns) {
    return (
      <>
        {reservationData !== null && (
          <ReservationListItem
            key={"wti-" + index}
            _key={"wti-" + index}
            listStyle="tight"
            id={"reservations-item-" + reservation.id}
            overwriteClasses={
              "inb-c-item inb-c-item--order inb-c-item-reservation row" + reservationData.addClasses
            }
            elements={reservationData.elements}
            setCheckoutReservation={setCheckoutReservation}
            setCheckoutCheckin={setCheckoutCheckin}
            hasValidCheckin={reservationData.hasValidCheckin}
            dispatch={dispatch}
            setFilter={setFilter}
            filter={filter}
            setNKey={setNKey}
            sort={sort}
            setSort={setSort}
            menu={reservationMenu}
            info={reservationData.info}
          />
        )}
      </>
    );
  } else if (reservationData.hasForm && !reservationData.hasMultipleCheckIns) {
    let orderMenu = [
      rbac.hasPermission("edit") && {
        text: t("edit_${a}", { a: t("order", null, "capital") }),
        href: "/orders/" + reservationLocal.order_id + "/edit" + currentUrl.search,
        iconClass: "fi fi-wrench",
        title: "edit",
      },
      rbac.hasPermission("edit") && {
        text: t("add_payment", null, "capital"),
        href:
          "/orders/" +
          reservationLocal.order_id +
          "/addpaymentfromreservations" +
          currentUrl.search,
        iconClass: "fi fi-dollar",
        title: "payments",
      },
      rbac.hasPermission("edit") && {
        text: t("create_ics", null, "capital"),
        href:
          "/orders/" +
          reservationLocal.order_id +
          "/" +
          t("order", null, "capital") +
          "_" +
          reservationLocal.order.order_nbr +
          " /ics" +
          currentUrl.search,
        iconClass: "fi fi-calendar",
        title: "ics",
      },
      rbac.hasPermission("log") && {
        text: t("show log"),
        href: "#",
        clickHandler: onShowLog,
        reservation: reservationLocal,
        getItem: "reservation",
        iconClass: "fi fi-wrench",
        title: "log",
      },
    ];
    /*if(Biscuit.get('user.is_superuser')  === 'true'){
                     orderMenu.push({
                         text: t('changelog', null, 'capital'),
                         href: "#",
                         clickHandler: openChangeLog,
                         changeLog: reservation.changeLogs,
                         iconClass: "fi fi-wrench",
                         title: "changelog"
                     });
                 }*/
    return (
      <>
        {reservationData !== null && (
          <OrderListItem
            order={reservationLocal.order}
            locations={locations}
            _exchangeLabel={_exchangeLabel}
            refLink={"reservations/reservationsList"}
            hasReservation={true}
            setCheckout={setCheckout}
            dispatch={dispatch}
            hasValidCheckin={reservationData.hasValidCheckin}
            length={
              typeof reservationLocal.order.reservations !== "undefined"
                ? reservationLocal.order.reservations.length
                : 1
            }
            key={"wti-" + index}
            _key={"wti-" + index}
            listStyle="tight"
            id={"row-" + reservation.order_id}
            overwriteClasses={
              "inb-c-item inb-c-item--order inb-c-item-reservation row" + reservationData.addClasses
            }
            elements={reservationData.elements}
            setFilter={setFilter}
            filter={filter}
            setNKey={setNKey}
            sort={sort}
            setSort={setSort}
            menu={orderMenu}
            info={reservationData.info}
          />
        )}
      </>
    );
  } else {
    let reservationMenu = [
      rbac.hasPermission("edit") && {
        text: t("edit_${a}", { a: t("order", null, "capital") }),
        href: "/orders/" + reservationLocal.order_id + "/edit" + currentUrl.search,
        iconClass: "fi fi-wrench",
        title: "edit",
      },
      rbac.hasPermission("edit") && {
        text: t("add_payment", null, "capital"),
        href:
          "/orders/" +
          reservationLocal.order_id +
          "/addpaymentfromreservations" +
          currentUrl.search,
        iconClass: "fi fi-dollar",
        title: "payments",
      },
      rbac.hasPermission("log") && {
        text: t("show log"),
        href: "#",
        clickHandler: onShowLog,
        reservation: reservationLocal,
        getItem: "reservation",
        iconClass: "fi fi-wrench",
        title: "log",
      },
    ];

    /*if(Biscuit.get('user.is_superuser')  === 'true'){
                reservationMenu.push({
                    text: t('changelog', null, 'capital'),
                    href: "#",
                    clickHandler: openChangeLog,
                    changeLog: reservation.changeLogs,
                    iconClass: "fi fi-wrench",
                    title: "changelog"
                });
            }*/
    return (
      <>
        {reservationData !== null && (
          <ReservationListExtraItem
            key={"wti-" + index}
            _key={"wti-" + index}
            listStyle="tight"
            id={"reservations-item-" + reservationLocal.id}
            overwriteClasses={
              "inb-c-item inb-c-item--order inb-c-item-reservation row" + reservationData.addClasses
            }
            elements={reservationData.elements}
            order={reservationLocal.order}
            reservationId={reservationLocal.id}
            reservation={reservationLocal}
            setCheckout={setCheckout}
            dispatch={dispatch}
            checkout={checkout}
            hasCompletedCheckouts={reservationData.hasCompletedCheckouts}
            hasFutureCheckout={reservationData.hasFutureCheckout}
            hasFutureCheckin={reservationData.hasFutureCheckin}
            _exchangeLabel={_exchangeLabel}
            length={reservationLocal.checkins.length}
            setCheckoutReservation={setCheckoutReservation}
            setCheckoutCheckin={setCheckoutCheckin}
            hasValidCheckin={reservationData.hasValidCheckin}
            app_user_role={Biscuit.get("user.role")}
            setFilter={setFilter}
            filter={filter}
            setNKey={setNKey}
            sort={sort}
            setSort={setSort}
            menu={reservationMenu}
            info={reservationData.info}
          />
        )}
      </>
    );
  }
};
export default ReservationItem;
